
    import BaseClass from '@/base'
    import { Component, Prop } from 'vue-property-decorator'

    @Component
    export default class LoadingComponentComponent extends BaseClass {
        @Prop({ type: Boolean }) readonly loaded!: boolean
    }
